// Seller gate: complete the membership by paying the rewards entry fee.
import type { LocalizedDict } from '../index'

export type EntryFeeGateStrings = {
  title: string
  intro: string
  rows: { fee: string; credit: string; creditHint: string; trial: string; trialValue: (days: number) => string }
  /** What the rest of the fee covers. Empty until Volkan writes it; the list hides when empty. */
  covers: string[]
  coversTitle: string
  start: string
  starting: string
  pay: (amount: string) => string
  paying: string
  failed: string
  tryAgain: string
  processingTitle: string
  processingBody: string
  stripeMissing: string
  loadError: string
  retry: string
}

export const entryFeeGateI18n: LocalizedDict<EntryFeeGateStrings> = {
  en: {
    title: 'Complete your membership',
    intro: 'A one-time entry fee opens your PEXIFY panel.',
    rows: {
      fee: 'Entry fee (one time)',
      credit: 'Credit added right away',
      creditHint: 'Spent on your first orders. It does not expire.',
      trial: 'Free subscription',
      trialValue: (days) => `${days} days`,
    },
    covers: [],
    coversTitle: 'Included',
    start: 'Continue to payment',
    starting: 'Preparing…',
    pay: (amount) => `Pay ${amount}`,
    paying: 'Processing…',
    failed: 'The payment did not go through.',
    tryAgain: 'Try another card or try again.',
    processingTitle: 'Payment received',
    processingBody: 'We are confirming it with the bank. Your panel opens in a few seconds.',
    stripeMissing: 'Card payments are not available right now. Please contact support.',
    loadError: "Couldn't load your membership.",
    retry: 'Try again',
  },
  tr: {
    title: 'Üyeliğini tamamla',
    intro: 'Bir kerelik giriş ücretiyle PEXIFY panelin açılır.',
    rows: {
      fee: 'Giriş ücreti (bir kerelik)',
      credit: 'Hemen eklenen kredi',
      creditHint: 'İlk siparişlerinde harcanır. Süresi dolmaz.',
      trial: 'Ücretsiz abonelik',
      trialValue: (days) => `${days} gün`,
    },
    covers: [],
    coversTitle: 'Neler dahil',
    start: 'Ödemeye geç',
    starting: 'Hazırlanıyor…',
    pay: (amount) => `${amount} öde`,
    paying: 'İşleniyor…',
    failed: 'Ödeme gerçekleşmedi.',
    tryAgain: 'Başka bir kart dene ya da tekrar dene.',
    processingTitle: 'Ödemen alındı',
    processingBody: 'Bankayla doğruluyoruz. Panelin birkaç saniye içinde açılacak.',
    stripeMissing: 'Kartla ödeme şu an kullanılamıyor. Lütfen destekle iletişime geç.',
    loadError: 'Üyelik bilgin yüklenemedi.',
    retry: 'Tekrar dene',
  },
}
